'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarFull;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function CalendarFull(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-calendar-full ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M14.625 5H1.375a.362.362 0 0 1-.266-.11A.362.362 0 0 1 1 4.626V3.5c0-.417.146-.77.437-1.062A1.447 1.447 0 0 1 2.5 2H4V.375c0-.104.036-.193.11-.266A.362.362 0 0 1 4.374 0h1.25c.104 0 .193.036.266.11.073.072.109.16.109.265V2h4V.375c0-.104.036-.193.11-.266A.362.362 0 0 1 10.374 0h1.25c.104 0 .193.036.266.11.073.072.109.16.109.265V2h1.5c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062v1.125a.362.362 0 0 1-.11.266.362.362 0 0 1-.265.109zM1.375 6h13.25c.104 0 .193.036.266.11.073.072.109.16.109.265V14.5c0 .417-.146.77-.438 1.062A1.447 1.447 0 0 1 13.5 16h-11c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 1 14.5V6.375c0-.104.036-.193.11-.266A.362.362 0 0 1 1.374 6zM5 12.375a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266A.362.362 0 0 0 4.626 8h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 5 9.626v-1.25zm4 4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266A.362.362 0 0 0 8.626 8h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 9 9.626v-1.25zm4 4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25z' })
  );
}

CalendarFull.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CalendarFull/CalendarFull.js
// module id = 167
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16